import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../../imageService';

const NoLongerManufacturedComponent = ({ brandId }) => {
  const brandList = ['chesterfield', 'marlboro', 'bond', 'philip-morris'];

  if (!brandList.includes(brandId)) return null;

  const getContentImage = (id) => {
    switch (id) {
      case 'chesterfield':
        return (
          <div className={styles.contentImageContainer}>
            <img
              src={getImageFromS3(
                'images/no-longer-manufactured/chesterfield.png'
              )}
              alt="chesterfield"
            />
          </div>
        );
      case 'marlboro':
        return (
          <div className={styles.contentImageContainer}>
            <img
              src={getImageFromS3('images/no-longer-manufactured/marlboro.png')}
              alt="marlboro"
            />
          </div>
        );
      case 'bond':
        return (
          <div className={styles.contentImageContainer}>
            <img
              src={getImageFromS3('images/no-longer-manufactured/bond.png')}
              alt="bond"
            />
          </div>
        );
      case 'philip-morris':
        return (
          <div className={styles.contentImageContainer}>
            <img
              src={getImageFromS3(
                'images/no-longer-manufactured/philip-morris.png'
              )}
              alt="philip-morris"
            />
          </div>
        );
      case 'lm':
        return (
          <div className={styles.contentImageContainer}>
            <img
              src={getImageFromS3('images/no-longer-manufactured/lm.png')}
              alt="lm"
            />
          </div>
        );
      default:
        return null;
    }
  };

  const getContentPackTitle = (id) => {
    switch (id) {
      case 'chesterfield':
        return (
          <p className={styles.contentPackTitle}>
            <b>Chesterfield Original 30</b> та
            <br />
            <b>Chesterfield Blue 30</b>
          </p>
        );
      case 'marlboro':
        return (
          <p className={styles.contentPackTitle}>
            <b>Marlboro Red XXL 40</b> та
            <br />
            <b>Marlboro Gold XXL 40</b>
          </p>
        );
      case 'bond':
        return (
          <p className={styles.contentPackTitle}>
            <b>
              Bond Street Blue
              <br /> Selection 25
            </b>
          </p>
        );
      case 'philip-morris':
        return (
          <p className={styles.contentPackTitle}>
            <b>Philip morris red 25 edition</b> та
            <br />
            <b>Philip morris blue 25 edition</b>
          </p>
        );
      case 'lm':
        return (
          <p className={styles.contentPackTitle}>
            <b>L&M Red Label XXL 40</b> та
            <br />
            <b>L&M Blue Label XXL 40</b>
          </p>
        );
      default:
        return null;
    }
  };

  const getContentDisclaimerText = (id) => {
    switch (id) {
      case 'chesterfield':
        return (
          <>
            Залишаються в продажу сигарети
            <br />
            <b>Chesterfield Original</b> та{' '}
            <b>
              Chesterfield
              <br />
              Blue
            </b>{' '}
            у <span>форматі 20 шт</span> в пачці
          </>
        );
      case 'marlboro':
        return (
          <>
            Залишаються в продажу сигарети
            <br />
            <b>Marlboro Red</b> та <b>Marlboro Gold</b> у{' '}
            <span>
              форматі
              <br /> 20 шт
            </span>{' '}
            в пачці
          </>
        );
      case 'bond':
        return null;
      case 'philip-morris':
        return (
          <>
            Залишаються в продажу сигарети
            <br />
            <b>Philip Morris Red</b> та <b>Philip Morris Blue</b> у{' '}
            <span>форматі 20 шт</span> в пачці
          </>
        );
      case 'lm':
        return (
          <>
            Залишаються в продажу сигарети
            <br />
            <b>L&M Red Label XXL 40</b> та <b>L&M Blue Label XXL 40</b> у{' '}
            <span>форматі 20 шт</span> в пачці
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.contentContainer}>
        <p className={styles.contentTitle}>СИГАРЕТИ</p>
        {getContentPackTitle(brandId)}
        {getContentImage(brandId)}
        <div className={styles.contentDescription}>
          Вже не виготовляються та не імпортуються
        </div>
        <a
          className={styles.lawLink}
          href="https://zakon.rada.gov.ua/laws/show/3817-20/conv#n2141"
          target="_blank"
        >
          Відповідно до абз.10 пп.3 п.3 розд. XII "Прикінцеві положення" ЗУ
          №3817-IX від 18.06.2024
        </a>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 315 400" fill="none">
        <path
          d="M0 10C0 4.47717 4.47715 0 10 0H305C310.523 0 315 4.47715 315 10V380.934C315 386.457 310.523 390.934 305 390.934H197.404C196.637 390.934 195.873 391.022 195.126 391.197L157.5 400L119.874 391.197C119.127 391.022 118.363 390.934 117.596 390.934H10C4.47715 390.934 0 386.457 0 380.934V10Z"
          fill="url(#paint0_linear_65_419)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_65_419"
            x1="158"
            y1="-22.6648"
            x2="158"
            y2="330"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#6D0000" />
            <stop offset="0.222441" stopColor="#3B0678" />
            <stop offset="0.75" stopColor="#2F0066" />
            <stop offset="1" stopColor="#270053" />
          </linearGradient>
        </defs>
      </svg>
      <p className={styles.disclaimerTitle}>
        {getContentDisclaimerText(brandId)}
      </p>
    </div>
  );
};

export default NoLongerManufacturedComponent;
